import { render } from "./ManageCatalogs.vue?vue&type=template&id=8abecb66"
import script from "./ManageCatalogs.vue?vue&type=script&lang=js"
export * from "./ManageCatalogs.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__